"use client"
import { HttpTypes, StoreCartPromotion } from "@medusajs/types"
import { Button, Input } from "@/components/atoms"
import { Heading, Label } from "@medusajs/ui"
import { useState } from "react"
import { applyPromotions, applyPromotionsReferral } from "@/lib/data/cart"
import { toast } from "@/lib/helpers/toast"
import { useTranslate } from "@tolgee/react"
export default function CartPromotionCode({
  cart,
}: {
  cart:
  | (HttpTypes.StoreCart & { promotions?: HttpTypes.StorePromotion[] })
  | null
}) {

  const [promotionCode, setPromotionCode] = useState("")
  const [isLoading, setIsLoading] = useState(false)
  const {t} = useTranslate()  
  
  const [appliedPromoCodes, setAppliedPromoCodes] = useState(
    () =>
      cart?.promotions?.map((p) => {
        const prom = p as StoreCartPromotion & { referral_code: string }
        return {
          id: prom.id,
          code: prom.code,
          referral_code: prom.referral_code,
          is_automatic: prom.is_automatic,
        }
      }) ?? []
  )

  const handleApplyPromotionCode = async () => {
    setIsLoading(true)
    try {
      const {applied:res, promotions} = await applyPromotionsReferral([promotionCode])
      if (res) {
        toast.success({ title: t("cart_review.promotion_code_applied") })
      } else {
        toast.error({ title: t("cart_review.promotion_code_not_found") })
      }
      setPromotionCode("")
      setAppliedPromoCodes(
        promotions.map(p => {
          const prom = p as StoreCartPromotion & { referral_code: string }
          return {
            id: prom.id,
            code: prom.code,
            referral_code: prom.referral_code,
            is_automatic: prom.is_automatic
          }
        })
      )
    } catch (err) {
      console.log(err)
    } finally {
      setIsLoading(false)
    }
  }

  return (
    <div>
      <Heading
        level="h2"
        className="flex flex-row gap-x-2 items-center text-[15px] font-medium leading-[22.5px] text-[#1a1a1a] mb-[11.25px]"
      >
        {t("cart_review.promotion_codes")}
      </Heading>
      <div>
        {appliedPromoCodes?.map((promo) => (
          <div
            key={promo.id}
            className="mb-4 flex flex-row gap-x-2 items-center"
          >
            <Label className="text-md">{promo.referral_code}</Label>
          </div>
        ))}
      </div>
      <Input
        placeholder={t("cart_review.enter_promotion_code")}
        value={promotionCode}
        onChange={(e) => setPromotionCode(e.target.value)}
        className="h-[33.75px] py-0 rounded-[9.375px] border-[#e5e5e5] bg-[rgba(240,240,240,0.4)] text-[15px] placeholder:text-[rgba(140,140,140,0.6)]"
      />
      <div className="flex justify-end mt-[11.25px]">
        <Button
          className="h-[29.25px] min-w-[100px] px-[15px] py-0 rounded-[9.375px] flex justify-center items-center bg-[#f0f0f0] text-[#8c8c8c] text-[14px] font-medium disabled:bg-[#F0F0F0] disabled:text-[#8C8C8C] whitespace-nowrap"
          onClick={handleApplyPromotionCode}
          disabled={isLoading || !promotionCode}
          loading={isLoading}
          variant="tonal"
        >
          {t("cart_review.use_promotion_code")}
        </Button>
      </div>
    </div>
  )
}
